export var AppId;
(function (AppId) {
    AppId["uMeds"] = "uMeds";
    AppId["alternaleaf"] = "alternaleaf";
})(AppId || (AppId = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uZmlnL2lkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLEtBR1g7QUFIRCxXQUFZLEtBQUs7SUFDZix3QkFBZSxDQUFBO0lBQ2Ysb0NBQTJCLENBQUE7QUFDN0IsQ0FBQyxFQUhXLEtBQUssS0FBTCxLQUFLLFFBR2hCIn0=